/* Un booleano de la base son TRES estados, y el tercero es el que importa.
 *
 * ── POR QUÉ ESTO SALIÓ DE ADENTRO DE `lona.js` ───────────────────────────
 *
 * La lona ya lo tenía resuelto. Cuando apareció la segunda columna con la
 * misma forma —`puerta`, que carga Federico desde `/FurgonesApp`— la salida
 * fácil era copiar las cinco líneas. Copiadas, el día que se agregue una sexta
 * forma de escribir «no» una columna la entendería y la otra no, y el síntoma
 * sería una tabla que dice «Sin dato» sobre un furgón cargado.
 *
 * Es la misma razón por la que `Ubicacion`, `ChipUsuario` y `VeredictoRTO`
 * salieron de adentro de sus pantallas.
 *
 * ── LA TRAMPA QUE ESTO EVITA ─────────────────────────────────────────────
 *
 * ACEPTA EL TEXTO ADEMÁS DEL BOOLEANO. Las columnas son `boolean` de verdad,
 * pero el formulario y PostgREST pueden mandar `"true"` según por dónde pase,
 * y el padrón ya tiene la cicatriz: `estado` guarda cinco formas distintas del
 * mismo sí/no. Leerlo con `!!v` haría que el string `"false"` —que es
 * VERDADERO en JavaScript— contara como «sí». Ese bug exacto ya pasó en
 * `estado.js` y no se repite.
 *
 * ── Y «NO SABEMOS» NO SE DICE COMO «NO» ──────────────────────────────────
 *
 * `SIN_DATO` es un estado propio. Dibujado igual que «no tiene», la lista de
 * lo que falta cargar arranca con la flota entera adentro y el trabajo no se
 * ve nunca. Es la regla del psicofísico sin fecha, de las 86 unidades que no
 * reportaron urea y de los cuatro estados de la última ubicación.
 *
 * EL GEMELO ESTÁ EN FLOTABOT: `furgones_taller.tres_estados`, que es lo que
 * escribe estas columnas desde `/FurgonesApp`. Si tocás una, tocá la otra.
 */

export const SI = "si";
export const NO = "no";
export const SIN_DATO = "sin_dato";

export function tresEstados(valor) {
  if (valor === true || valor === "true" || valor === 1 || valor === "1")
    return SI;
  if (valor === false || valor === "false" || valor === 0 || valor === "0")
    return NO;
  return SIN_DATO;
}
